import { useIsMobile } from '@/hooks/use-mobile';
import {
  OrdersDrilldownDialog,
  type OrdersDrilldownDialogProps,
} from '@/components/orders-drilldown/orders-drilldown-dialog';
import { OrdersDrilldownSheet } from '@/components/orders-drilldown/orders-drilldown-sheet';

/** Chart drill-down: bottom sheet below 768px, the dialog from there up (SALES-06 AC 3, 4). */
export function OrdersDrilldown(props: OrdersDrilldownDialogProps) {
  return useIsMobile() ? (
    <OrdersDrilldownSheet {...props} />
  ) : (
    <OrdersDrilldownDialog {...props} />
  );
}
